import React from 'react';

import classnames from 'classnames';
import styled from 'styled-components';

import { usePagination, DOTS } from './usePagination';
import Arrow from '../../atoms/icons/Arrow';

import { COLORS } from '../../../utils/theme/colors';

export const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange?.[paginationRange?.length - 1];
  return (
    <PaginationWrapper
      className={classnames('pagination-container', { [className]: className })}
    >
      <li
        className={classnames('pagination-item', {
          disabled: currentPage === 1,
        })}
        onClick={onPrevious}
      >
        <Arrow fill={'#444'} className='right_arrow' />
      </li>
      {paginationRange?.map((pageNumber) => {
        if (pageNumber === DOTS) {
          return <li className='pagination-item dots'>&#8230;</li>;
        }

        return (
          <li
            className={classnames('pagination-item', {
              selected: pageNumber === currentPage,
            })}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </li>
        );
      })}
      <li
        className={classnames('pagination-item', {
          disabled: currentPage === lastPage,
        })}
        onClick={onNext}
      >
        <Arrow fill={'#444'} className='left_arrow' />
      </li>
    </PaginationWrapper>
  );
};

const PaginationWrapper = styled.ul`
  display: flex;
  list-style-type: none;
  flex-direction: row;
  margin-top: 13px;
  padding-bottom: 10px;
  justify-content: flex-end;
  align-items: center;
  user-select: none;

  .pagination-item {
    background-color: ${COLORS.transparentDark};
    height: 35px;
    width: 35px;
    border-radius: 100%;
    margin: 0 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color 200ms ease-in-out;
    cursor: pointer;

    &:hover {
      background-color: ${({ theme }) => theme.hoveredDiv};
      color: ${COLORS.primary};
    }

    &:hover path {
      stroke: ${COLORS.primary};
    }

    &.selected {
      background-color: ${({ theme }) => theme.hoveredDiv};
      color: ${COLORS.primary};
    }

    &.dots {
      cursor: default;
    }

    &.disabled {
      pointer-events: none;
      cursor: default;

      svg path {
        stroke: rgba(0, 0, 0, 0.43);
      }

      &:hover {
        background-color: transparent;
      }
    }

    .left_arrow {
      transform: rotate(180deg);
    }
  }
`;
